export default __webpack_public_path__ + "static/media/gas-pump.e8d7545e.svg";